/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { checkStatus } from '../fn/ok/check-status';
import { CheckStatus$Params } from '../fn/ok/check-status';

@Injectable({ providedIn: 'root' })
export class OkService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `checkStatus()` */
  static readonly CheckStatusPath = '/aphealthcheck/v1/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkStatus$Response(params?: CheckStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return checkStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkStatus(params?: CheckStatus$Params, context?: HttpContext): Observable<void> {
    return this.checkStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
